export const DEFAULT_ZONE = 1;
export const GB_AREA_CODE_REGEX = /^([A-Z]{1,2})/;
